import { render, staticRenderFns } from "./ProjectSubmissionModule.vue?vue&type=template&id=aa3d5ad8&scoped=true&"
import script from "./ProjectSubmissionModule.vue?vue&type=script&lang=js&"
export * from "./ProjectSubmissionModule.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSubmissionModule.vue?vue&type=style&index=0&id=aa3d5ad8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3d5ad8",
  null
  
)

export default component.exports